import React from "react"
import { Nav, NavItem, NavLink } from "reactstrap"
import classnames from "classnames"
import AccessControlWrapper from "components/Common/PermissionButton"

const PermissionTabs = ({
    tabs = [],
    activeTab,
    onTabChange,
    isTabDisabled,
    tabPermissions = [],
    history,
    className = "",
    style,
}) => {
    const handleTabClick = (tabIndex) => {
        const tabIndexStr = String(tabIndex)

        if (activeTab === tabIndexStr) {
            return
        }

        if (!isTabDisabled || !isTabDisabled(tabIndex)) {
            onTabChange(tabIndexStr)
        }
    }

    const renderNavLink = (tab, tabIndex, disabled, isCurrentTab, hasPermission = true) => (
        <NavLink
            style={{
                cursor: isCurrentTab ? "default" : (disabled || !hasPermission ? "not-allowed" : "pointer"),
                opacity: disabled || !hasPermission ? 0.5 : 1
            }}
            className={classnames({
                active: isCurrentTab, 
                disabled: disabled || !hasPermission,
            })}
            onClick={() => {
                if (!disabled && hasPermission && !isCurrentTab) {
                    handleTabClick(tabIndex)
                }
            }}
        >
            {tab}
            {(!hasPermission && !isCurrentTab) && <i className="mdi mdi-lock-outline ms-1 text-muted"></i>}
        </NavLink>
    )

    return (
        <Nav tabs className={className} style={style}>
            {tabs.map((tab, index) => {
                const tabIndex = index + 1
                const disabled = isTabDisabled ? isTabDisabled(tabIndex) : false
                const permission = tabPermissions[index] || {}
                const isCurrentTab = activeTab === `${tabIndex}`
                
                // If no permission config OR current tab, render directly
                if (!permission.contextUri || !permission.actionType || isCurrentTab) {
                    return (
                        <NavItem key={index}>
                            {renderNavLink(tab, tabIndex, disabled, isCurrentTab, true)}
                        </NavItem>
                    )
                }

                // For non-current tabs with permissions
                return (
                    <NavItem key={index}>
                        <AccessControlWrapper
                            actionType={permission.actionType}
                            contextUri={permission.contextUri}
                            history={history}
                            fallback={renderNavLink(tab, tabIndex, disabled, false, false)}
                        >
                            {renderNavLink(tab, tabIndex, disabled, false, true)}
                        </AccessControlWrapper>
                    </NavItem>
                )
            })}
        </Nav>
    )
}

export default PermissionTabs